import React, {} from 'react';
import { Center, Container, Text, Stack, Box } from '@good/ui/core';
import { GroupOf3People } from '@good/illustrations';

export const BookingsTableEmptyState = () => (
  <Container mb='xl'>
    <Center py='xl'>
      <Stack align='center'>
        <GroupOf3People size='lg' />
        <Text size='lg' fw={700} ta='center'>
          No matching bookings found.
        </Text>
        <Box>
          <Text c='dimmed' ta='center'>
            All bookings under this filter will appear here.
          </Text>
          <Text c='dimmed' ta='center'>
            Try adjusting your filter, or clicking on another view.
          </Text>
        </Box>
      </Stack>
    </Center>
  </Container>
);
